import { render } from "./fileFill.vue?vue&type=template&id=ac74ee3c&scoped=true"
import script from "./fileFill.vue?vue&type=script&lang=js"
export * from "./fileFill.vue?vue&type=script&lang=js"

import "./fileFill.vue?vue&type=style&index=0&id=ac74ee3c&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac74ee3c"]])

export default __exports__